<template>
  <v-dialog :value="show" width="500" persistent @input="$emit('update:show', $event)">
    <v-card>
      <v-card-title class="dialog-header" color="primary"> Add to existing group </v-card-title>
      <v-divider />
      <v-container>
        <v-card-text>
          <v-form ref="existingGroupForm" v-model="formValid">
            <v-select
              class="pa-1"
              v-model="selectedGroupId"
              :items="groups"
              :loading="groupsLoading"
              item-text="groupName"
              item-value="groupId"
              :rules="[(v) => !!v || 'A group is required']"
              label="List Group"
              required
              no-data-text="No list groups found"
            >
              <template v-slot:append-item>
                <v-divider class="mb-2" v-if="hasMoreGroups"></v-divider>
                <v-list-item v-if="hasMoreGroups">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-btn depressed :disabled="groupsLoading" @click="$emit('load-more')"
                        >Load more +</v-btn
                      >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-form>
          <v-data-table
            :value="selectedUsers"
            :headers="groupColumns"
            :items="selectedUsers"
            item-key="userId"
            class="elevation-1"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
            no-data-text="No people found"
            :hide-default-footer="selectedUsers.length <= 10"
          >
            <template v-slot:[`item.displayName`]="{ item }">
              <span class="word-break">{{
                item ? item.tableDisplayName || item.displayName : ""
              }}</span>
            </template>
            <template v-slot:[`item.businessEmail`]="{ item }">
              <span class="word-break">
                {{ item.businessEmail || item.businessPhone }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="handleCancel"> Cancel </v-btn>
          <v-btn color="blue darken-1" text @click="handleAdd" :disabled="!formValid">
            Add to group
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ExistingGroupDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    groups: {
      type: Array,
      default: () => [],
    },
    groupsLoading: {
      type: Boolean,
      default: false,
    },
    groupsTotal: {
      type: Number,
      default: 0,
    },
    selectedUsers: {
      type: Array,
      default: () => [],
    },
    tableLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedGroupId: null,
      formValid: false,
      groupColumns: [
        { text: "Name", value: "displayName" },
        { text: "Email/Phone", value: "businessEmail" },
      ],
    };
  },
  computed: {
    hasMoreGroups() {
      return this.groupsTotal > this.groups.length;
    },
  },
  methods: {
    handleAdd() {
      if (this.formValid) {
        this.$emit("add", this.selectedGroupId);
      }
    },
    handleCancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    resetForm() {
      this.selectedGroupId = null;
      if (this.$refs.existingGroupForm) {
        this.$refs.existingGroupForm.reset();
      }
    },
  },
  watch: {
    show(val) {
      if (!val) {
        this.resetForm();
      }
    },
  },
};
</script>

<style scoped>
.word-break {
  word-break: break-word;
}
</style>
